import { Form } from "../../api";
import { energyKPIsCodes } from "./energyForms";
import { waterKPIsCodes } from "./waterForms";
import { wasteKPIsCodes } from "./wasteForms";
import { effluentKPIsCodes } from "./effluentForms";
import { fuelsKPIsCodes } from "./fuelsForms";

const formController = new Form();

const KPI_CODES_BY_ASPECT = {
  energy: energyKPIsCodes,
  water: waterKPIsCodes,
  waste: wasteKPIsCodes,
  effluent: effluentKPIsCodes,
  fuels: fuelsKPIsCodes,
};

// código KPI ("KPIene1") -> nombre de indicador ("electricity_standard_combined_kpis"),
// el mismo "name" que se guarda en Form.indicators[].yearBaseline (☰ → Datos → Línea Base).
function fieldKeyForKpiCode(aspect, kpiCode) {
  const catalog = KPI_CODES_BY_ASPECT[aspect];
  if (!catalog || !kpiCode) return null;
  return Object.keys(catalog).find((k) => catalog[k] === kpiCode) || null;
}

// Trae, una sola vez por aspecto, el Form de configuración (donde vive
// yearBaseline) para los aspectos indicados de un sitio.
export async function fetchBaselineYearsByAspect(accessToken, site, aspects) {
  const uniqueAspects = Array.from(new Set((aspects || []).filter(Boolean)));
  const entries = await Promise.all(
    uniqueAspects.map(async (aspect) => {
      try {
        const result = await formController.getFormsBySite(accessToken, site, aspect);
        return [aspect, result?.[0] || null];
      } catch (error) {
        return [aspect, null];
      }
    })
  );
  return Object.fromEntries(entries);
}

// Año de línea base configurado para el KPI de un objetivo, leído de
// ☰ → Datos → Línea Base (Form.indicators[].yearBaseline). Cae al yearBaseline
// general del módulo si el indicador puntual todavía no tiene uno propio.
export function getBaselineYearForKpi(aspect, kpiCode, formByAspect) {
  const form = formByAspect?.[aspect];
  if (!form) return null;
  const fieldKey = fieldKeyForKpiCode(aspect, kpiCode);
  const indicator = fieldKey ? form.indicators?.find((i) => i.name === fieldKey) : null;
  const year = indicator?.yearBaseline ?? form.yearBaseline ?? null;
  return year ? Number(year) : null;
}
